import { select } from '@js/util/select.js'
import $ from 'jquery'

select('.confirm-dialog-wrap', element => {
  let $dialog = $(element)
  let storageKey = $dialog.data('storage-key')
  let activeClass = 'confirm-dialog-unseen'

  let open = function () {
    $dialog.addClass(activeClass)
  }
  let close = function () {
    if (localStorage) {
      localStorage.setItem(storageKey, false)
    }
    $dialog.removeClass(activeClass)
  }

  if (localStorage && !localStorage.getItem(storageKey)) {
    open()
  }
  $dialog.find('.close-button').on('click', close)
})
